/**
 * riskreducer.js
 * Created by calhosh on 11/6/2019.
 */

import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {entities, HttpStatusCodes} from '../../util/uiconstants';

const deleteRiskFromStore = (riskId, state, isManageEstimate = false) => {
	let clonedState = _.cloneDeep(state);
	if (isManageEstimate) {
		clonedState.manageEntities.data = clonedState.manageEntities.data?.filter((entity) => entity.id !== Number(riskId));
		return clonedState;
	}
	clonedState.data = clonedState.data?.filter((entity) => entity.id !== Number(riskId));
	return clonedState;
};

// Reducer for modal-specific risks (paginated, for RelateRiskControlModal)
export function modalRisksReducer(state = initialstate.modalRisks, action) {
	switch (action.type) {
		case types.GET_MODAL_RISKS:
			return action.response || state;
		default:
			return state;
	}
}

export function getAllEngagementRisksReducer(state = initialstate.allEngagementRisks, action) {
	switch (action.type) {
		case types.GET_ALL_ENGAGEMENT_RISKS:
			return action.response || state;
		default:
			return state;
	}
}
export function risksListReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.GET_RISKS_SAME_API_SORTING:
			if (action?.response?.data && !action.error) {
				const data = {
					list: action.response.data.map((currentRow) => {
						currentRow.relatedTasks = [];
						(currentRow.responsiveTasksV2 ?? []).forEach((currentResponsiveTasksV2) => {
							const relatedTasks = (currentResponsiveTasksV2?.responsiveSubstantiveTask ?? []).map((task) => {
								task.riskId = currentResponsiveTasksV2?.riskId;
								return task;
							});
							currentRow.relatedTasks.push(...relatedTasks);
						});
						return currentRow;
					})
				};
				data.pages = action.response.pages;
				data.page = action.response?.page;
				data.totalEntityCount = action.response.totalEntityCount;
				return {...state, ...data};
			}
			return state;
		default:
			return state;
	}
}

export function listRisksReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.LIST_RISKS:
			if (action?.response?.data && !action.error) {
				const data = {
					list: action.response.data.map((risk = {}) => ({
						riskName: risk?.riskName ?? '',
						riskTypeId: risk?.riskTypeId ?? null,
						id: risk?.id ?? null,
						isHigherRisk: risk?.isHigherRisk ?? false,
						rationale: risk?.rationale ?? ''
					}))
				};
				data.pages = action.response.pages;
				data.page = action.response?.page;
				data.totalEntityCount = action.response.totalEntityCount;
				return {...state, ...data};
			}
			return state;
		default:
			return state;
	}
}
export function standardRisksReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.GET_STANDARD_RISKS_FOR_CFC:
			return action.response || state;
		default:
			return state;
	}
}

export function risksReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.GET_RISKS:
			if (action?.isEstimateLeadsheet) {
				let newState = _.cloneDeep(state);
				newState.estimates = action.response;
				return newState;
			}
			if (action?.isManageEntities) {
				let newState = _.cloneDeep(state);
				newState.manageEntities = action.response;
				return newState;
			}
			return action.response || state;

		case types.UPDATE_GET_ALL_RISK_STORE_BY_ID:
			if (action.response) {
				let newState = _.cloneDeep(state);
				let toBeUpdateIndex = state.data.findIndex((x) => x.id == action.response.id);
				newState.data[toBeUpdateIndex] = action.response;
				return newState;
			}
			return state;
		case types.GET_RISK_BY_ID:
			// If the risk is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response.status === HttpStatusCodes.NotFound) return deleteRiskFromStore(action.riskId, state, action?.isManageEntities);
			return state;
		case types.UPDATE_RISK:
			if (action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromStore(action.risk.id, state, action?.isManageEntities);
			}

			if (action?.error) {
				return state;
			}
			if (action?.isManageEntities) {
				let newState = _.cloneDeep(state);
				if (newState?.manageEntities?.data) {
					let updatedEstimates = newState.manageEntities.data.filter((e) => e.id !== action.response.id);
					newState.manageEntities.data = [...updatedEstimates, action.response];
				}

				return newState;
			}
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState = _.cloneDeep(state);
				const editIndex = newState?.data?.findIndex((x) => x.id === action.response.id);
				if (editIndex > -1) {
					newState.data[editIndex] = action.response;
				}

				return newState;
			}

			return state;

		case types.CREATE_RISK:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let newState;
				if (Object.keys(state).length === 0) {
					newState = {
						data: [action.response],
						manageEntities: {data: [action.response]}
					};
				} else {
					newState = _.cloneDeep(state);
					if (action.isManageEntities) {
						newState = {
							...newState,
							manageEntities: {data: [...(state.manageEntities?.data || []), action.response]}
						};
						return newState;
					}
					newState.data = [..._.cloneDeep(state.data), action.response];
				}
				return newState;
			}
			return state;
		case types.DELETE_RISK: {
			if (action.responseObj.status === HttpStatusCodes.Ok || action.error.response.status === HttpStatusCodes.NotFound) {
				return deleteRiskFromStore(action.riskId, state, action?.isManageEntities);
			}
			return state;
		}

		case types.RELATE_SCOT_TO_RISK:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return {...state, riskScot: action.response};
			}
			return state;

		case types.UNRELATE_SCOT_TO_RISK:
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			break;

		case types.RELATE_CFC_TO_RISK:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				return state;
			}
			return state;

		case types.UNRELATE_CFC_TO_RISK:
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			break;

		case types.RELATE_ESTIMATE_TO_RISK: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Created) {
				return state;
			}
			return state;
		}

		case types.UNRELATE_ESTIMATE_TO_RISK: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			return state;
		}
		case types.RELATE_SPECIAL_CIRCUMSTANCE_TO_ROMM: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Created) {
				return state;
			}
			return state;
		}
		case types.UNRELATE_SPECIAL_CIRCUMSTANCE_TO_ROMM: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			return state;
		}
		case types.CLEAR_RISKS:
			return {};
		default:
			return state;
	}
}

export function wcgwRelatedRisksReducer(state = initialstate.wcgwRelatedRisks, action) {
	switch (action.type) {
		case types.GET_RISKS_FOR_WCGWID:
			return action.response.value || state;

		default:
			return state;
	}
}

export function relatedRisksReducer(state = initialstate.wcgwRelatedRisks, action) {
	switch (action.type) {
		case types.GET_RELATED_RISKS_FOR_WCGWID:
			return action.response || state;
		default:
			return state;
	}
}

export function newRiskReducer(state = initialstate.risks, action) {
	switch (action.type) {
		case types.CREATE_RISK:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				return action.response;
			}
			return state;
		case types.CLEAR_NEW_RISK:
			return {};
		default:
			return state;
	}
}

export function riskReducer(state = initialstate.risk, action) {
	switch (action.type) {
		case types.CREATE_RISK:
			if (action?.isManageEntities) {
				let newState = _.cloneDeep(state);
				newState.createEditEstimate = action.response;
				return newState;
			}
			return action.response || state;
		case types.GET_RISK_BY_ID: {
			// If the risk is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response?.status === HttpStatusCodes.NotFound) return deleteRiskFromStore(action.riskId, state);
			if (action?.isManageEntities) {
				let newState = _.cloneDeep(state);
				newState.createEditEstimate = action.response;
				return newState;
			}
			const resp = action.response?.data || action.response;
			return {
				...state,
				...resp,
				riskITApplications: resp.riskITApplications !== null ? resp.riskITApplications : state.riskITApplications
			};
		}
		case types.GET_TOP_ENTITY_METADATA:
			// If the risk is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response?.status === HttpStatusCodes.NotFound) return deleteRiskFromStore(action.riskId, state);
			if (action.response && action.entity && action.entity === entities.Estimate) {
				return {
					...action.response,
					isDisplayEstimateTypeMismatchClientSideValidationMessage: true
				};
			}
			return state;
		case types.UPDATE_TOP_ENTITY_METADATA: {
			let updatedRisk = _.cloneDeep(state);
			updatedRisk.riskName = action.payload?.riskName;
			updatedRisk.riskTypeId = action.payload?.riskTypeId;
			updatedRisk.comparativePeriodDate = action.payload?.comparativePeriodDate;
			updatedRisk.comparativePeriodBalance = action.payload?.comparativePeriodBalance;
			updatedRisk.analysisPeriodDate = action.payload?.analysisPeriodDate;
			updatedRisk.analysisPeriodBalance = action.payload?.analysisPeriodBalance;
			return updatedRisk;
		}
		case types.CLEAR_RISK:
			if (action?.isManageEntities) {
				let newState = _.cloneDeep(state);
				newState.createEditEstimate = {};
				return newState;
			}
			return {};
		case types.DISPLAY_ESTIMATETYPE_MISMATCH_CLIENT_VALIDATION_MESSAGE: {
			let risk = _.cloneDeep(state);
			risk.isDisplayEstimateTypeMismatchClientSideValidationMessage = action.isDisplayEstimateTypeMismatchClientSideValidationMessage;
			return risk;
		}
		case types.UPDATE_STORE_RELATE_SCOT_TO_RISK: {
			let risk = _.cloneDeep(state);
			if (risk.scots === null) {
				risk.scots = [];
			}
			risk.scots.push(action.payload.scotData);
			risk.scots.sort((a, b) => a.scotName.localeCompare(b.scotName));

			return risk;
		}
		case types.UPDATE_RISK:
			if (action.responseObj.status === HttpStatusCodes.Ok) {
				let updatedRisk = _.cloneDeep(state);
				if (action?.isManageEntities) {
					updatedRisk.createEditEstimate = action.response;
					return updatedRisk;
				}			
				updatedRisk.riskTypeId = action.response.riskTypeId;
				updatedRisk.riskName = action.response.riskName;
				return updatedRisk;
			}
			return state;

		case types.UPDATE_STORE_UNRELATE_SCOT_TO_RISK: {
			let risk = _.cloneDeep(state);
			let riskIndex = risk.scots.findIndex((scot) => scot.riskID === action.payload.riskID && scot.scotID === action.payload.scotID);
			if (riskIndex !== -1) {
				risk.scots.splice(riskIndex, 1);
			}
			return risk;
		}
		case types.RELATE_ESTIMATE_TO_RISK: {
			if (action.response && action.responseObj.status === HttpStatusCodes.Created) {
				let updatedRisk = _.cloneDeep(state);
				updatedRisk.riskTypeId = action.response.riskTypeId;
				return updatedRisk;
			}
			return state;
		}

		case types.UNRELATE_ESTIMATE_TO_RISK: {
			if (action.responseObj.status === HttpStatusCodes.NoContent) {
				return state;
			}
			return state;
		}

		case types.UPDATE_STORE_UNRELATE_ACCOUNT_TO_RISK: {
			let risk = _.cloneDeep(state);
			let riskIndex = risk.accounts.findIndex((account) => account.id === action.payload.accountID);
			if (riskIndex !== -1) {
				risk.accounts.splice(riskIndex, 1);
			}
			return risk;
		}
		case types.PATCH_RISK: {
			if (action.response) {
				return {
					...action.response
				};
			}
			return state;
		}

		default:
			return state;
	}
}

export function relateRiskReducer(state = initialstate.relateRisks, action) {
	switch (action.type) {
		case types.GET_RISKS_TO_RELATE:
			return action.response || state;
		default:
			return state;
	}
}

/*
 Group Risks by Risk Types
 */
export function groupRisksByRiskTypes(risks) {
	let risksGroupedByRiskTypes = {};
	if (risks && risks.data && risks.data.length > 0) {
		risksGroupedByRiskTypes = _.chain(risks.data)
			// Group the elements of Array based on `risk type id` property
			.groupBy('riskTypeId')
			// `key` is group's name (risk type id), `value` is the array of objects (risks)
			.map((value, key) => ({riskTypeId: key, risks: value}))
			.value();
	}
	return risksGroupedByRiskTypes;
}

export function formatRisks(risks) {
	let formattedRisks = [];
	if (risks && risks && risks.length > 0) {
		formattedRisks =
			risks &&
			risks.map((risk) => {
				return {
					...risk,
					riskAbbreviation: risk.riskAbbreviation && risk.riskAbbreviation.slice(0, 1)
				};
			});
	}

	return formattedRisks;
}
